'use strict';// Public API for Zone
var ng_zone_1 = require('./zone/ng_zone');
exports.NgZone = ng_zone_1.NgZone;
exports.NgZoneError = ng_zone_1.NgZoneError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiem9uZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImFuZ3VsYXIyL3NyYy9jb3JlL3pvbmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsc0JBQXNCO0FBQ3RCLHdCQUFrQyxnQkFBZ0IsQ0FBQztBQUEzQyxrQ0FBTTtBQUFFLDRDQUFtQyIsInNvdXJjZXNDb250ZW50IjpbIi8vIFB1YmxpYyBBUEkgZm9yIFpvbmVcbmV4cG9ydCB7Tmdab25lLCBOZ1pvbmVFcnJvcn0gZnJvbSAnLi96b25lL25nX3pvbmUnO1xuIl19


/*****************
 ** WEBPACK FOOTER
 ** ./~/angular2/src/core/zone.js
 ** module id = 406
 ** module chunks = 0
 **/